import { api } from '../api';

interface UnitListParams {
  tenantId?: string;
  sectorId?: string;
  page?: number;
  limit?: number;
  search?: string;
}

export const unitService = {
  list: (params?: UnitListParams) => api.get('/units', { params }),
  get: (id: string) => api.get(`/units/${id}`),
  create: (data: any) => api.post('/units', data),
  update: (id: string, data: any) => api.put(`/units/${id}`, data),
  remove: (id: string) => api.delete(`/units/${id}`),
};